module.exports = __webpack_public_path__ + "static/media/015.e80209e0.jpg";